module.exports = __webpack_public_path__ + "img/youtube.f905f67c.svg";